import styled, { css } from 'styled-components';

export const SwitchContainer = styled.button<{ checked: boolean }>`
  border: 0;
  border-radius: 1rem;
  cursor: pointer;
  display: flex;
  overflow: hidden;
  height: 1.04rem;
  width: 1.85rem;

  align-items: center;

  ${({ checked, theme }) =>
    !checked
      ? css`
          background: ${theme.gray4};
        `
      : css`
          background: ${(props) => props.theme.success};
        `};

  div {
    background: #fff;
    border-radius: 5rem;
    height: 0.903rem;
    width: 0.903rem;
    transition: all 0.2s linear;
    transform: ${({ checked }) =>
      !checked ? 'translateX(0.1rem)' : 'translateX(0.8rem)'};
  }
`;
